module.exports = __webpack_public_path__ + "static/media/instagramsvg.73552a2f.svg";